export const getArgOrCallback = (arg, rest = null) => {
	if (typeof arg === "function") {
		return arg(rest);
	} else {
		return arg;
	}
};
